const PREFIX = "[PostureLoop:transition]"

function transitionLoggingEnabled() {
  return document.documentElement.dataset.railsEnv !== "production"
}

export function alertContext() {
  const notificationsSupported = "Notification" in window

  return {
    hidden: document.hidden,
    visibilityState: document.visibilityState,
    notificationsSupported,
    notificationPermission: notificationsSupported ? Notification.permission : "unsupported",
    secureContext: window.isSecureContext
  }
}

export function logTransition(stage, data = {}) {
  if (!transitionLoggingEnabled()) return

  console.log(PREFIX, stage, { ...alertContext(), ...data })
}
